import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import yup from 'yup-legacy'
import createReactClass from 'create-react-class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import { withGettext } from 'lib/gettext'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import {
  FormComponentMixin,
  ValidationBox,
  Form,
  Input,
  Submit,
} from 'legacy/libs/react-form-tools'
import Popup from 'legacy/libs/components/popup'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import TagMixin from '../mixins/tag'

import s from './suggest-tag.module.scss'

const SuggestTag = createReactClass({
  mixins: [SchemaBranchMixin, TagMixin, FormComponentMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    createService: PropTypes.func,
    tree: PropTypes.oneOfType([BaobabPropTypes.baobab, BaobabPropTypes.cursor]),
  },

  schema: {
    pk: null,
    childrenTags: {
      data: [],
    },
    childrenCount: 0,
    suggestTagForm: {},
    submitDisabled: false,
  },

  validationSchema: yup.object().shape({
    name: yup.string().required(),
  }),

  cursors(props, context) {
    return {
      currentSuggestWindow: ['global', 'suggestWindow'],
      selectedTags: this.getCursor(props, context),
    }
  },

  isSuggestWindowOpen() {
    return this.state.currentSuggestWindow === this.props.tree.hash
  },

  closeSuggestWindow() {
    this.cursors.currentSuggestWindow.set(null)
  },

  openSuggestWindow() {
    this.cursors.currentSuggestWindow.set(this.props.tree.hash)
  },

  onSuggestClick() {
    if (this.isSuggestWindowOpen()) {
      this.closeSuggestWindow()
    } else {
      this.openSuggestWindow()
    }
  },

  onCancelSuggestClick() {
    this.closeSuggestWindow()
  },

  onSubmit(data) {
    this.cursors.submitDisabled.set(true)
    const performedData = _.merge({ parentTag: this.state.pk }, data)

    this.props
      .createService(performedData)
      .then((tagData) => {
        this.cursors.submitDisabled.set(false)

        // Add tag to tree
        this.cursors.childrenTags.select('data').push(tagData)
        this.cursors.childrenCount.apply((x) => x + 1)

        // Select new tag
        const tagCursor = this.cursors.childrenTags.select('data', {
          pk: tagData.pk,
        })
        this.selectTagsTree(tagCursor)

        // Reset form and close
        this.cursors.suggestTagForm.set({})
        this.closeSuggestWindow()
      })
      .catch(() => this.cursors.submitDisabled.set(false))
  },

  render() {
    const { gettext } = this.props

    return (
      <div className={s.container}>
        <button className={s.text} onClick={this.onSuggestClick} type="button">
          <FontAwesomeIcon icon={faPlusCircle} aria-hidden="true" />
          {gettext('Suggest a tag')}
        </button>

        {this.isSuggestWindowOpen() && (
          <Form
            ref="content"
            cursor={this.cursors.suggestTagForm}
            validationSchema={this.validationSchema}
            onSubmit={this.onSubmit}
          >
            <Popup modifier="suggest-tag">
              <ValidationBox fieldPath="name" className="validationbox">
                <label className={s.label}>{gettext('Name')}</label>
                <Input className="input" maxLength="140" autoFocus />
              </ValidationBox>

              <div className={s.description}>
                {gettext(
                  'The suggested tag will be added to your ' +
                    'entry after it’s approved.'
                )}
              </div>

              <Submit
                className="btn-submit"
                disabled={this.state.submitDisabled}
              >
                {gettext('Suggest')}
              </Submit>

              <div className="btn-cancel" onClick={this.onCancelSuggestClick}>
                {gettext('Cancel')}
              </div>
            </Popup>
          </Form>
        )}
      </div>
    )
  },
})

export default withGettext(SuggestTag)
